import { StyleSheet } from "@react-pdf/renderer";

export const stylesPDF = StyleSheet.create({
  page: { 
      paddingTop: 30, 
      paddingBottom: 30, 
      paddingHorizontal: 50,
      fontFamily:"Tahoma"
  },
  heroBanner: {
      width: "100%",
      height: 250,
      backgroundColor: "#383838", // azul de fondo
      flexDirection: "row",
      alignItems: "center",
      paddingHorizontal: 35,
  },
  bannerTitle: {
      fontSize: 30,
      color: 'white',
      fontWeight: 600,
      marginBottom: "10px"
  },
  bannerTitle2: {
      fontSize: 20,
      color: 'white',
      fontWeight: 'bold',
  },
  bannerSubtitle: {
      fontSize: 20,
      color: '#F4C542',        
      fontWeight: 400,
      marginBottom: "20px"
  },
  bannerSubtitle2: {
      fontSize: 12,
      color: '#F4C542',        
      fontWeight: 400,
      marginTop: 4,
  },
  bannerText: {
      fontSize: 14,
      color: 'white',        
      fontWeight: 400,
      marginTop:"5px"
  },
  LogoContainer:{
      display:"flex",
      flexDirection:"column",
      justifyContent:"center"
  },
  textView:{
      paddingTop: 10,
      paddingBottom: 30,
      paddingHorizontal: 45,
  },
  bannerMiniContainer: {
      paddingHorizontal:40,
      paddingVertical: 20,
      width: '100%',
      justifyContent:"center",
      marginBottom:5,
  },
  normalText:{
      fontSize:11.5,
      fontWeight:400,
      flexShrink: 1,
      marginTop:20,
      lineHeight:1.25
  },
  cardContainer: {
      marginHorizontal: 30,
      marginVertical:10,
      paddingVertical: 15,
      paddingHorizontal: 20,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      borderRadius: 5
  },
  textColumn: {
    flex: 1,
  },
  titleText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  infoText: {        
    fontSize: 10,
    lineHeight: 1.4,
  },
  buttonBox: {
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 4,
    marginLeft: 20,
  },
  buttonText: {
    color: '#FFFFFF',
    fontSize: 8,
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  linkText:{
    textDecoration:"none",
    color:"white"
  },
  sectionWrapper: {
    paddingTop: 20,
    paddingBottom: 20,
    paddingHorizontal: 50,
    backgroundColor: '#FFC7001A',
    marginBottom: 10,
    flexDirection: 'column',
    alignItems: 'center',
  },
  sectionTextColumn: {
    width: '65%',
  },
  sectionImageColumn: {
    width: '35%',
    alignItems: 'flex-end', 
  },
  sectionNumber: {
    fontWeight: 'bold',
    fontSize: 22,
    marginBottom: 4,
  },
  sectionImage: {
    width: '50%',
    alignItems:"flex-end"
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
    color: '#333333',
  },
  intro: {
    marginTop: 0,
  },
  tableContainer: {
    marginHorizontal: 40,
    marginVertical: 20,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#FFFFFF', // Para separar filas si el fondo es igual
  },
  tableHeader: {
    backgroundColor: '#F4C542',
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  tableCell: {
    backgroundColor: '#FFC7001A', // Tu color backSections.main
    padding: 15,
    justifyContent: 'center',
  },
  col3: {
    width: '30%',
  },
  col9: {
    width: '70%',
  },
  col12: {
    width: '100%',
    backgroundColor: '#FFC7001A',
    padding: 20,
  },
  headerText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 12,
  },
  rowText: {
    fontSize: 10,
    color: '#333',
    textAlign:"left"
  },
  footerText: {
    fontSize: 11,
    marginTop: 5,
  },
  resultsContainer: {
    backgroundColor: "#FFF8E1",
    paddingVertical: 16,
    paddingHorizontal: 40,
    marginVertical: 4,
  },
  resultsTitle: {
    fontSize: 15,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 12,
    color: "#333",
  },
  resultsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 10,
  },
  resultCard: {
    flexDirection: "column",
    width: "31%",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 10,
  },
  resultsSideBySide: {
    flexDirection: "row",
    marginHorizontal: 30,
    marginTop: 20,
  },
  resultsColumn: {
    flex: 1,
    borderRadius: 10,
    paddingVertical: 18,
    paddingHorizontal: 16,
    gap: 10,
  },
  resultsDivider: {
    width: 2,
    backgroundColor: "#D4AF37",
    marginHorizontal: 8,
    borderRadius: 1,
  },
  resultCardStacked: {
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  resultValueStacked: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#383838",
    marginTop: 2,
  },
  resultPill: {
    alignSelf: "flex-start",
    borderRadius: 12,
    paddingVertical: 3,
    paddingHorizontal: 10,
    marginBottom: 8,
  },
  resultPillText: {
    fontSize: 10,
    fontWeight: "bold",
    color: "#FFFFFF",
  },
  resultBlock: {
    flexDirection: "column",
    alignItems: "center",
    width: "30%",
  },
  resultLabel: {
    fontSize: 12,
    fontWeight: "bold",
    marginBottom: 4,
    minHeight: 16,
  },
  resultValue: {
    fontSize: 11,
    fontWeight: "bold",
    color: "#383838",
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center', 
    marginVertical: 20,       
    marginHorizontal: 'auto',
  },
  outroImage: {
    width: 300,
    height: 'auto',
    borderRadius: 10,
  },
  pageNumber: {
    position: 'absolute',
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 9,
    color: '#888888',
  },
})